function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import './FormLabel.css';
import cs from 'classnames';
import I18n from '../../I18n/I18n/I18n';
import HelpTemplate from '../../SchemaForm/HelpTemplate/HelpTemplate';
import RequiredIndicator from '../../SchemaForm/RequiredIndicator/RequiredIndicator';
import whitelistProps from '../../utils/whitelistProps';
import GroupContext from '../../SchemaForm/GroupTemplate/GroupContext';
import getLabelId from '../getLabelId';
var whitelist = whitelistProps();
export default function FormLabel(_ref) {
  var theme = _ref.theme,
    _ref$metaType = _ref.metaType,
    metaType = _ref$metaType === void 0 ? '' : _ref$metaType,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? 'label' : _ref$element,
    type = _ref.type,
    htmlFor = _ref.htmlFor,
    i18n = _ref.i18n,
    _ref$escape = _ref.escape,
    escape = _ref$escape === void 0 ? true : _ref$escape,
    icons = _ref.icons,
    required = _ref.required,
    requiredId = _ref.requiredId,
    description = _ref.description,
    size = _ref.size,
    hidden = _ref.hidden,
    view = _ref.view,
    error = _ref.error,
    attrs = _objectWithoutProperties(_ref, ["theme", "metaType", "element", "type", "htmlFor", "i18n", "escape", "icons", "required", "requiredId", "description", "size", "hidden", "view", "error"]);
  var topLabels = size === 'small' || theme === 'wm';
  var Icons = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RequiredIndicator, {
    required: required,
    id: requiredId
  }), icons);
  var Element = element;
  var InnerLabel = /*#__PURE__*/React.createElement(Element, Object.assign({
    id: getLabelId(htmlFor),
    htmlFor: element === 'label' ? htmlFor : null,
    className: cs("_dm-label _dm-label--".concat(size), "_dm-label--".concat(type, " _dm-label--").concat(type, "--").concat(size), "_dm-label--".concat(element, " _dm-label--").concat(element, "--").concat(size), "_dm-label--".concat(theme, "--").concat(element, " _dm-label--").concat(theme, "--").concat(element, "--").concat(size), "_dm-label--".concat(theme, " _dm-label--").concat(theme, "--").concat(size), "_dm-label--".concat(theme, "--").concat(type, " _dm-label--").concat(theme, "--").concat(type, "--").concat(size), "".concat(error ? "_dm-label-error" : ""), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      '_dm-label-layout': !description
    }, "_dm-label-layout--".concat(size), !description), "_dm-label-layout--".concat(theme), !description), "_dm-label-layout--".concat(theme, "--").concat(size), !description), "_dm-label--".concat(metaType), metaType), "_dm-label--".concat(metaType, "--").concat(size), metaType), "_dm-label--".concat(theme, "--").concat(metaType), metaType), "_dm-label--".concat(theme, "--").concat(metaType, "--").concat(size), metaType), "_dm-label--".concat(metaType, "--").concat((view || '').toLowerCase()), view && metaType), 'auto-label-container', _defineProperty(_defineProperty({}, "auto-label-container--".concat(metaType), metaType), "auto-label-container--".concat(type), type))
  }, whitelist(attrs)), /*#__PURE__*/React.createElement("span", {
    className: cs('_dm-label__inner', {
      'assistive-text': hidden
    })
  }, !topLabels && Icons, /*#__PURE__*/React.createElement("span", {
    className: "auto-label"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n,
    escape: escape
  })), topLabels && Icons));
  if (description) {
    return /*#__PURE__*/React.createElement(LabelWrapper, {
      size: size,
      description: description,
      i18n: i18n,
      escape: escape,
      theme: theme
    }, InnerLabel);
  } else {
    return InnerLabel;
  }
}
function LabelWrapper(_ref2) {
  var size = _ref2.size,
    description = _ref2.description,
    i18n = _ref2.i18n,
    escape = _ref2.escape,
    children = _ref2.children,
    theme = _ref2.theme;
  var group = useContext(GroupContext);
  var topLabels = size === 'small' || theme === 'wm' || group;
  var className = cs("_dm-label-layout", "_dm-label-layout--".concat(size), "_dm-label-layout--".concat(theme), "_dm-label-layout--".concat(theme, "--").concat(size));
  var helpTemplate = /*#__PURE__*/React.createElement(HelpTemplate, {
    description: description,
    i18n: i18n,
    escape: escape
  });
  if (topLabels) {
    return /*#__PURE__*/React.createElement("span", {
      className: className
    }, children, helpTemplate);
  } else {
    return /*#__PURE__*/React.createElement("span", {
      className: className
    }, helpTemplate, children);
  }
}